export default __webpack_public_path__ + "static/media/Squeeze_placement-17.54f5cc9d.png";